import { createContext } from "react";

export type TokensContextType = {
  tokensDisponiveis: number | null;
  statusTokens: { tokens_atuais: number; limite_tokens: number } | null;
  atualizarTokens: () => Promise<void>;
  decrementarTokens: (quantidade: number) => void;
  calcularTokensDisponiveis: (status: { tokens_atuais: number; limite_tokens: number }) => number;
  estimarTokensNecessarios: (temImagem: boolean) => number;
  validarTokensSuficientes: (temImagem: boolean) => { suficiente: boolean; tokensNecessarios: number; tokensDisponiveis: number };
};

export const TokensContext = createContext<TokensContextType>(null!);
